import { StoreSchema } from '../../types/store'

export const selectSideBarState = (store: StoreSchema) => store.sideBar